<template>
<el-row type="flex" justify="center" :gutter="20" v-if="show">
  <el-col :xs="24" :sm="24" :md="22" :lg="14">
    <div class="empty-content" v-loading="loadingStatus" element-loading-text="玩命加载中...">

          <el-card >
            <div class="content-text">
              <h2><p>暂无内容</p></h2>
            </div>
          </el-card>
    </div>
  </el-col>
</el-row>
</template>
<script>
import '../../static/style/common/emptycontent.scss'
import {mapGetters, mapActions} from 'vuex';

export default {
    props: ['show', 'loading'],
    data: () => ({

    }),
    computed: {
        ...mapGetters({
            // 映射 this.getLoadingStatus 为 store.getters.getLoadingStatus
            getLoadingStatus: 'getLoadingStatus',
        }),
        loadingStatus(){
          // console.debug("loadingStatus> %o", this.getLoadingStatus);
          return this.getLoadingStatus;
        }
    },
    methods: {
        ...mapActions({
          // 映射 this.updateLoadingStatus() 为 this.$store.dispatch('updateLoadingStatus')
        })
    }
}
</script>



// WEBPACK FOOTER //
// emptycontent.vue?6eae3fba